import React, { useContext } from 'react';
import { CashoutConfigurationContext } from '../../../../data/cashout/CashoutConfigurationCtx';
import Img from '../Img';

export default function CashoutIcon(props) {
    const cashoutConf = useContext(CashoutConfigurationContext);
    const bet = props.bet;
    let cashoutEnabled = false;
    
    const matchData = bet.odds[0]?.matchData ?? null;
    if (matchData != null) {
        cashoutEnabled = cashoutConf.isCashoutEnabledForSelection(matchData.sportRef,
                                                                  matchData.tournamentRef,
                                                                  matchData.pal,
                                                                  matchData.avv,
                                                                  bet.cs,
                                                                  bet.h,
                                                                  matchData.isLive);
    }
    
    if (!cashoutEnabled) {
        return null;
    }

    return (
        <Img className="c_10_1_4" src="cashout.svg" />
    );
}
